<template>
  <div id="shop">
      <ul>
        <li class="radius05rem overHidden whiteB relativeItem" v-for="(n, index) in 3" :key="index">
          <router-link to="/shopDetial" class="allA"></router-link>
          <p>这里是标题</p>
          <div class="img">
            <img src="../../assets/banner.png">
          </div>
        </li>
      </ul>
  </div>
</template>

<script>

export default {
  name: "shop",
  components: {
  },
  data() {
    return {
    };
  },
  methods: {
    
  },
  mounted: function() {
    this.$tool.setTitle("首页");
    this.$emit("showOhidden", false, 0);
    
  },
};
</script>

<style scoped lang="scss">
#shop{
  padding: .8rem;
  li{margin-bottom: 10px;}
  p{padding:.5rem;font-size: 14px;}
  .img{
    padding: 0 .5rem;
    img{width: 100%;}
  }
}
</style>
